import React from 'react';
import CredentialLanding from '../components/CredentialLanding/CredentialLanding';

export default function Home() {
  return (
    <CredentialLanding />
  );
}
